export default "__VITE_ASSET__DdWRMLTV__"